import React, { useEffect, useState } from 'react'
import styles from './style/tab_style.module.scss';
import Typography from '../../foundations/typography/Typography'
import PropTypes from 'prop-types'

const TYPEFACE_TAB = 'title-m-light'
const TYPEFACE_SELECTOR = 'title-s-light'
const TYPEFACE_CHIP_S = 'body-xs-regular'
const TYPEFACE_CHIP_M = 'body-s-regular'

const Tab = ({ children, onClick, className= '', style = {}, gtmLabel, ...props }) => {

    const [isSelected, setIsSelected] = useState(false)
    const [classes, setClasses] = useState(className)

    useEffect(() => {
        const _styles = [styles.tab]
        if (classes) _styles.push(classes)
        Object.keys(props).forEach(key => {
            if (key !== 'selected' && TAB_PROPTYPES[key]) _styles.push(styles[key])
        })
        const _classes = _styles.join(' ');
        if (_classes)  setClasses(_classes)
    }, [])

    const typography = () => {
        let typeface

        if (props['style-selector']) typeface = TYPEFACE_SELECTOR
            else if (props['style-chip-s']) typeface = TYPEFACE_CHIP_S
                else if (props['style-chip-m']) typeface = TYPEFACE_CHIP_M
                    else typeface = TYPEFACE_TAB

        return (
            <Typography typeface={typeface}>
                {children}
            </Typography>
        )
    }

    return (
        <div
            className={`${classes}${(isSelected || props.selected) ? (' ' + styles.selected) : ''}`}
            style={style}
            onClick={() => {
                if (!props.disabled) {
                    if (!("selected" in props)) setIsSelected(!isSelected)
                    onClick && onClick()
                }
            }}
            gtm-label={gtmLabel}
        >
            {typography()}
        </div>
    );
};

const TAB_PROPTYPES = {
    'style-tab': PropTypes.bool,
    'style-selector': PropTypes.bool,
    'style-chip-s': PropTypes.bool,
    'style-chip-m': PropTypes.bool,
    selected: PropTypes.bool,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
}

Tab.propTypes = TAB_PROPTYPES

export default Tab;
